<template>
  <div class="all-search wh-flex-start">
    <wh-search-input
      style="width: 400px"
      :btn-icon="'el-icon-search'"
      :placeholder="'请输入搜索关键字内容'"
      :value.sync="search"
      @search="searchFn"
    />
    <div v-if="keyList.length" class="key-warp wh-flex-start">
      <span class="key-title">热点关键词：</span>
      <span
        v-for="(item, index) in keyList"
        :key="index"
        :title="item"
        class="key-item wh-text-overflow"
        @click="itemTap(item)"
      >{{ item }}</span>
    </div>
  </div>
</template>

<script>
import WhSearchInput from '@/components/SearchInput/SearchInput'
import { setLocal } from '@/utils/tool'
import dayjs from 'dayjs'
export default {
  name: 'AllSearch',
  components: { WhSearchInput },
  data() {
    return {
      search: '',
      allKeyList: [
        '国家标准',
        '标准体系',
        'GB/T 13016-2018',
        '国家标准',
        '标准体系',
        'GB/T 13016-2018',
        '国家标准',
        '标准体系',
        'GB/T 13016-2018',
        '国家标准',
        '标准体系',
        'GB/T 13016-2018',
        '国家标准',
        '标准体系',
        'GB/T 13016-2018',
        '国家标准',
        '标准体系',
        'GB/T 13016-2018'
      ],
      keyList: []
    }
  },
  created() {
    this.randomKey()
  },
  methods: {
    searchFn(val) {
      if (val) {
        // this.saveKey(val)
        this.$emit('search', val)
      }
    },
    itemTap(item) {
      this.search = item
      this.$emit('search', item)
      // this.saveKey(item)
    },
    saveKey(item) {
      this.keyList = this.keyList.filter(it => it !== item)
      this.keyList.unshift(item)
      this.keyList = this.keyList.slice(0, 3)
      setLocal('globalKet', this.keyList)
    },
    randomKey() {
      const oneDay = 24 * 60 * 60 * 1000
      const dayNum = Math.ceil((dayjs().valueOf() - dayjs('2000-01-01').valueOf()) / oneDay)
      this.keyList = this.allKeyList.splice(dayNum % 10, 3)
    }
  }
}
</script>

<style lang="less" scoped>
  .all-search{
    height: 80px;
    padding: 0 50px;
    background-color: #fff;
    .key-warp{
      margin-left: 33px;
      font-size: 14px;
      .key-title{
        color: #77788A;
      }
      .key-item{
        color: #C9C8CD;
      }
      span:not(:first-child){
        max-width: 80px;
        cursor: pointer;
        &:hover{
          color: #409eff;
        }
      }
      span:not(:last-child){
        margin-right: 12px;
      }
    }
  }
</style>
